import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { TaskSummary } from '@/components/features/tasks/payment/TaskSummary';
import { TaskProgress } from '@/components/features/tasks/payment/TaskProgress';
import { TaskFiles } from '@/components/features/tasks/payment/TaskFiles';
import { Comments } from '@/components/features/tasks/payment/Comments';
import { ToDoList } from '@/components/features/tasks/payment/ToDoList';
import { Activities } from '@/components/features/tasks/payment/Activities';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { ProjectInfo } from '@/components/features/tasks/payment/ProjectInfo';
import { ContractAlert } from '@/components/features/tasks/payment/ContractAlert';
import { GenerateAfterCompletedAlert } from '@/components/features/tasks/payment/GenerateAfterCompletedAlert';

export const BackofficePaymentTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_ } = useCurrentWorkspace();
  useEffect(() => setTitle('支払タスク詳細'), []);
  useEffect(
    () => setBreadcrumbs([{ label: `支払タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/payment_tasks` }]),
    []
  );

  const { paymentTask: task } = useCurrentPaymentTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <ContractAlert />
        <GenerateAfterCompletedAlert />

        <div className="row">
          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>

          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
